module.exports = __webpack_public_path__ + "media/homeVideo.9a7effb4.mp4";